import React from 'react';

// Quick reactions for the reaction picker (reduced to 8 for mobile fit)
const quickReactions = ['❤️', '😂', '😮', '😢', '😡', '🎉', '👏', '🔥'];

interface ReactionPickerProps {
  messageId: string;
  onReaction: (messageId: string, emoji: string) => void;
  onClose?: () => void;
}

export function ReactionPicker({ messageId, onReaction, onClose }: ReactionPickerProps) {
  return (
    <div className="flex justify-center mb-2 animate-fade-in" onClick={(e) => e.stopPropagation()}>
      <div
        className="px-2 py-1.5 flex space-x-0.5 max-w-[calc(100vw-32px)]"
        style={{
          borderRadius: '999px',
          background: 'rgba(248,250,252,0.98)',
          backdropFilter: 'blur(24px) saturate(200%)',
          WebkitBackdropFilter: 'blur(24px) saturate(200%)',
          border: '1px solid rgba(15,23,42,0.10)',
          boxShadow: '0 0 0 0.5px rgba(255,255,255,0.8) inset, 0 8px 24px rgba(15,23,42,0.18), 0 2px 6px rgba(15,23,42,0.08)',
        }}
      >
        {quickReactions.map((emoji, index) => (
          <button
            key={emoji}
            onClick={(e) => {
              e.stopPropagation();
              onReaction(messageId, emoji);
              onClose?.();
            }}
            className="w-8 h-8 tap-target inline-flex items-center justify-center hover:bg-slate-100/80 rounded-full transition-all duration-150 text-base hover:scale-110 active:scale-95 animate-scale-in shrink-0"
            style={{ animationDelay: `${index * 50}ms` }}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}

